import { render } from "./FieldDelete.vue?vue&type=template&id=73cdf190"
import script from "./FieldDelete.vue?vue&type=script&lang=js"
export * from "./FieldDelete.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.15.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__